/* eslint-disable react/prop-types */
import React, { useState, useMemo , useRef} from 'react';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import esLocale from "date-fns/locale/es";
import { 
    Tooltip,
    TextField,
    FormControl,
    FormLabel,
    // RadioGroup,
    // FormControlLabel,
    // withStyles,
    // Radio,
    MenuItem,
    Typography
} from '@material-ui/core';


import { useTable } from "react-table";
import PropTypes from 'prop-types';
import {  useForm } from 'react-hook-form';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';


import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';




import '../../styles/style.scss';

import Modal from './Modal';



import DataStatus from '../../constants/customComponent/DataStatus';
import ReferenceModal from './ReferenceModal';
import Swal from 'sweetalert2';
import paymentService from '../../services/payment.service';
import { actionErrorConnection } from '../../constants/component/actionErrorConnection';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import {   DatePicker,  MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { format } from 'date-fns';


const filterState = [
  {value: "F", label:"Fecha"},
  {value: "M", label: "Monto" },
  {value: "MyF", label: "Monto y Fecha"},
  {value: "RyF", label: "Referencia y Fecha"},
  {value: "RyM", label: "Monto y Referencia"},
]
export const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });

export const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
export const ReferenceDetailScreen = () => {

    const dispatch = useDispatch();
    const history = useHistory();

    const currencySelected = 'es-Mx';

    const sessionDifference = timeSessionDifference();
    const [selectedStatusValue, setSelectedStatusValue] = useState("Facturas");
  
    const [startDate, setStartDate] = useState(new Date()); // Fecha de hoy
    const [endDate, setEndDate] = useState(() => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1); // Suma 1 día para obtener la fecha de mañana
        return tomorrow;
    });
    const [isLoadingFilters, ] = useState(false);
    const [detailPayment, setDetailPayment] = useState([]);
    const [detailPaymentFilter, setDetailPaymentFilters] = useState([]);
    const detailPaymentRef = useRef();
    
    const [suggestedReferences, setReferenceSuggestion] = useState([])
    const [referencePam, setReferencePam] = useState("")
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [amount, setAmount] = useState("");
    const [errorResponse, setErrorResponse] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);
    const [filterParams, setFilterParams] = useState("")
    detailPaymentRef.current = detailPayment;
    const {
      register,
        handleSubmit,
        getValues,
        reset,
        setError,
        clearErrors,
        formState: { errors },
      } = useForm({
      });
      
    //  const CustomRadio = withStyles({
    //     root: {
    //       color: font.baseCheckboxColor,
    //       "&$checked": {
    //         color: font.baseColor,
    //       },
    //     },
    //     checked: {},
    //   })((props) => <Radio color="default" {...props} />);

      
    /** 
     * Recupera el an8 seleccionado
     * @author alSanchez - ETE
     * @version 1.0.0 - Noviembre 2023
     * 
    */
  // const onCustomerChange = () =>{
  //   const params = getValues();

  //   if(params.an8 && params.an8 !== ''){ 
  //     setIsLoadingData(true)
  //     getReferenceDetail(params.an8, "n")
  //     //let date = new Date();

  //   //const year = date.getFullYear();
  //   //const month = date.getMonth()+1<10 ? `0${date.getMonth()+1}`: date.getMonth()+1;

  //   //onSubmit(null, year, month, false); 
  //   return
  //   }
  // }
  const onCustomerChange = (data) =>{
    if(data.target.value === "RyF" ){
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setStartDate(new Date());
      setEndDate(tomorrow);
      reset((formValues) =>({
        ...formValues,
        amountFrom: "",
        amountUpTo: "",
      }))
    }
    if(data.target.value === "RyM" ){
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setStartDate(new Date());
      setEndDate(tomorrow);
    }
    if(data.target.value === "MyF" ){
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setStartDate(new Date());
      setEndDate(tomorrow);
      reset((formValues) =>({
        ...formValues,
        refStatus: "",
      }))
      setReferencePam("")
    }
    if(data.target.value === "F" ){
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setStartDate(new Date());
      setEndDate(tomorrow);
      reset((formValues) =>({
        ...formValues,
        amountFrom: "",
        amountUpTo: "",
        refStatus: "",
      }))
    }
    if(data.target.value === "M" ){
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setStartDate(new Date());
      setEndDate(tomorrow);
      reset((formValues) =>({
        ...formValues,
        refStatus: "",
      }))
    }

    if (data.target.value ) {
       setFilterParams(data.target.value)
    }
  }

    /**
     * Realiza la solicitud para recuperar datos de pago por filtros
     * @param {*} data - información del formulario
     * @param {string} year - año a consultar
     * @param {string} month - mes a consultar
     * @param {boolean} pagination - valida si fue solicitado un cambio de pagina
     * @param {boolean} pageSizeChange - valida si fue realizada una solicitud de cambio de tamaño en tabla
     * @param {number} pageChange - cantidad de datos a obtener en la tabla
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021

     */
    const onSubmit = () => {

      const params = getValues();
      console.log("params", params)
    
     if(params.filterSelector === "RyM"){
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setStartDate(new Date());
      setEndDate(tomorrow);
     } 
     if(params.filterSelector === "M"){
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setStartDate(new Date());
      setEndDate(tomorrow);
     }

      console.log(startDate, endDate)
      const refStatusPay = params.refStatus === undefined ? "": params.refStatus;
      if(params.amountFrom && params.amountUpTo && parseFloat(params.amountFrom) > parseFloat(params.amountUpTo)){
        setError('amountFrom', {
          type: 'manual',
          message: 'El monto inicial debe ser menor que el monto final',
        });
        setError('amountUpTo', {
          type: 'manual',
          message: 'El monto final debe ser mayor que el monto inicial',
        });
        return;
      }else{
        
        const element = document.getElementById('collapseExample');
        element.classList.remove('show');
        clearErrors('amountFrom');
        clearErrors('amountUpTo');
        
      setIsLoadingData(true);
      
   
    
      getReferenceDetail("n",refStatusPay)
      setAmount("")
    }
    
  // }
    
    // let filteredResponse = selectedStatusValue === "Facturas" || selectedStatusValue === ""   ? detailPayment?.filter(({billType})=> billType !== "")  : detailPayment?.filter(({billType})=> billType === "") 
    // switch(params.refStatus){
    //   case "p" : 
    //     setIsLoadingData (false) 
    //     setDetailPaymentFilters(filteredResponse.filter(({reference})=> reference !== null))
      
    //   ;break;
    //   case "np" : 
    //     setIsLoadingData (false) 
    //       setDetailPaymentFilters(filteredResponse.filter(({reference})=> reference === undefined || reference === "" || reference === null))
        
    //       ;break;
    //   case "n" : 
    //     setIsLoadingData (false)  
    //     setDetailPaymentFilters(filteredResponse);
    //   break;
    // }
      //const pageSizeFilter =  pageSizeChange || pageSize;
      //const pageFilter = !pagination ? 1 : getPageSize();

      //getServiceDetailPayment(dataFilter, an8, pageSizeFilter, pageFilter)
    };
      const formtaDateHour = (startDate, endDate) =>{
        const params = getValues();
       
        if(params.filterSelector === "RyM" || params.filterSelector === "M"){
          setStartDate("");
          setEndDate("");
          return {startDateFormat: "", endDateFormat: ""}
        }
        if(startDate === "" || endDate === "") return {startDateFormat: "", endDateFormat: ""}
        const startDateObject = new Date(startDate);
        const startDateFormat = format(startDateObject, 'yyyy-MM-dd', { locale: esLocale });
        const endDateFormat = format(endDate, 'yyyy-MM-dd', { locale: esLocale });
        return {startDateFormat, endDateFormat}
      }
      const getReferenceDetail = (referenceType,refPam="")=>{
        setDetailPayment([])
        setDetailPaymentFilters([])
        setSelectedStatusValue("Facturas")
        const amountBill = getValues().amountFilter || 0
        const {amountFrom, amountUpTo} = getValues()
        const {startDateFormat, endDateFormat} = formtaDateHour(startDate, endDate)
        paymentService.getReferenceDetailService(referenceType,refPam, startDateFormat, endDateFormat,amountFrom, amountUpTo)
        .then((response) => {
          
          console.log("responsee", response)
          setIsErrorResponse(false);
          setIsLoadingData(false);
          setDetailPayment(response);
          reset((formValues) =>({
            ...formValues,
            amountFrom: "",
            amountUpTo: "",
            refStatus: "",
          }))
          setReferencePam("")
          console.log(typeof( response[0]?.billDate),"====================")
          if(Number(amount)>0) {
            const filteredData = response.filter(({ amount }) => {
              return amount.toString().includes(amountBill.toString())
            }
          )
          setDetailPaymentFilters(filteredData)
          }else{

            setDetailPaymentFilters(response)
          }
         
        }).catch((error) => {
              setIsLoadingData(false);
              if(error.response){
                setErrorResponse(error.response.data.mensaje);
                if(sessionDifference > Number(tokenExpired)){
                  sesionExpired(dispatch, history);
                }
              } else{
                setErrorResponse(error);
                actionErrorConnection(error);
              }
              setIsErrorResponse(true);
            });
          
  
      }


        /**
         * Realiza solicitud a servicio para recuperar detalle de pagos procesados
         * @param {*} dataFilter - datos de filtos
         * @author alSanchez - ETE
         * @version 1.0.0 - Octubre 2021
         */
        // const getServiceDetailAdvancePayment = (dataFilter) =>{
        //   DetailAdvancePaymentService.getAlldetailPaymentByFilters(dataFilter)
        //   .then((response) => {
        //     setIsErrorResponse(false);
        //     setIsLoadingData(false);
        //     setDetailAdvancePayment(response);
        //   })
        //   .catch((error) => {
        //     setIsLoadingData(false);
        //     console.log(error);
        //     if(error.response){
        //       setErrorResponse(error.response.data.mensaje);
        //       if(sessionDifference > Number(tokenExpired)){
        //         sesionExpired(dispatch, history);
        //       }
        //     } else{
        //       setErrorResponse(error);
        //       actionErrorConnection(error);
        //     }
        //     setIsErrorResponse(true);
        //   });
        // }


    /**
     * Realiza solicitud a servicio para recuperar detalle de pagos procesados
     * @param {*} dataFilter - datos de filtos
     * @param {*} pageSizeFilter - campos a obtener
     * @param {*} pageFilter - pagina a obtener
     * @author alSanchez - ETE
     * @version 1.0.0 - Octubre 2021
     */
    // const getServiceDetailPayment = (dataFilter, an8, pageSizeFilter, pageFilter) =>{
    //   DetailPaymentService.getAlldetailPaymentByFilters(dataFilter,an8, pageSizeFilter, pageFilter)
    //   .then((response) => {
    //     setIsErrorResponse(false);
    //     setIsLoadingData(false);
    //     const { invoicePaid, total } = response;
    //     setDetailPayment(invoicePaid);
    //     setCount(Math.ceil(total/pageSizeFilter));
    //   })
    //   .catch((error) => {
    //     setIsLoadingData(false);
    //     console.log(error);
    //     if(error.response){
    //       setErrorResponse(error.response.data.mensaje);
    //       if(sessionDifference > Number(tokenExpired)){
    //         sesionExpired(dispatch, history);
    //       }
    //     } else{
    //       setErrorResponse(error);
    //       actionErrorConnection(error);
    //     }
    //     setIsErrorResponse(true);
    //   });
    // }
    
      /**
     * Actualiza referencia del pago seleccionado dentro de la trabla
     * @param {*} updateItem - Objeto del pago seleccionado en la tabla
     * @author Kenzo Sashida - ETE
     * @version 1.0.0 - Abril 2025
     */
    const updateReferenceTable = (payment) =>{
      setDetailPaymentFilters((prevState)=>
        prevState.map((item,index)=> index === Number(payment.idRow) ? {...item, reference: payment.reference} : item)
    )
      setDetailPayment((prevState)=>
        prevState.map((item,index)=> index === Number(payment.idRow) ? {...item, reference: payment.reference} : item)
    )
    
      // const value = detailPayment.map((item,index)=> index === Number(payment.id) ? {...item, reference: payment.reference} : item)
      // setDetailPayment(value)
      // setDetailAdvancePayment(value)
      // setDetailPaymentFilters(value)
    }
    
  
    /**
     * Campos de la tabla
     */
    const columnsPayment = useMemo(
      () => [
        {
          Header: 'Cliente',
          accessor: 'nuCustomer',
        },
        {
          Header: "Tipo pago",
          Cell: ({row})=>{
            if(row.original.billType === "" || row.original.billType === null){ 
              return "Anticipo/Contado"
            }else{
              return "Facturas"
            }
          }
        },
        {
          Header: "Num. factura",
          accessor: "billNumber",
          Cell:({row})=>{
            if(row.original.billNumber === "" || row.original.billNumber === null){ 
              return "-"
            }else{
              return row.original.billNumber
            }
            
           
          }
        },
        {
          Header: "Tipo factura",
          accessor: "billType",
          Cell:({row})=>{
            if(row.original.billType === "" || row.original.billType === null) {
              return "-"
            }else {
              return row.original.billType
            }
           
          }
        },        
        {
          Header: "Fecha operación",
          accessor: "registrationDate",
          Cell:({row})=>{
            if(row.original.registrationDate === "" || row.original.registrationDate === null) return "-"
            const datePayment = format(new Date(row.original.registrationDate), 'dd/MM/yyyy', { locale: esLocale });
            return datePayment
          }
        },
        {
          Header: "Monto",
          accessor: "amount",
        },
        {
          Header: "Referencia",
          accessor: "reference",
          Cell:({row})=>{
            const dataPayment = {...row.original, idRow: row.id }
            
            if (dataPayment.reference !== null) {
             return dataPayment.reference
          } else {
              return (
                    <p style={{textAlign:"center"}} className="text-danger  mt-3">Sin referencia</p>
              );
          }
          }
        }
        ,
        {
          Header: "Num. compañía",
          accessor: "company",
        }
        ,
        {
          Header: "Item de pago",
          accessor: "paymentItem",
        }
        ,

        {
          Header: "Acciones",
          
          Cell: ({row})=>{ 
            const dataPayment = {...row.original, idRow: row.id }
            const handleClick = ()=>{
              swalCustomButtons.fire({
                title: 'Aceptar',
                text: "Solo podrás actualizar la referencia 1 sola vez.",
                  icon: 'warning',
                  showConfirmButton: true,
                  confirmButtonText: 'Aceptar',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  reverseButtons: true
                }).then((result) => {
                  if(result.isConfirmed) document.getElementById(`reference-detail-${row.index}`)?.click()
                
                })
            }
            return (
              <>

               <button className="btn" onClick={handleClick} aria-label='Edit item'>
                  <i className="fas fa-eye link-secondary" color='primary'></i>
                </button>
                <ModalDetailPayment
                  row={row}
                  dataPayment={dataPayment}
                  updateReferenceTable={updateReferenceTable}
                  
                />
              </>
          );
          }
        }
      ],
      []
    );
  
    

    //   const filterPayment = ()=>{
        
    //     return detailPayment
      
    // }
    // const handleChangeStatus = (event) => {
    //   setSelectedStatusValue(event.target.value);
    //   const dataToTable = filterPayment(event.target.value);
    //   setDetailPaymentFilters(dataToTable);
    //      };
    const columns =  columnsPayment  
    const dataTable = detailPaymentFilter
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow
    } = useTable({
      columns,
      data: dataTable,
    });

    const handleSetReferencePam = (item) =>{
      if(item.refPam === null || item.refPan === "") return
      setReferencePam(item.refpan)
      setReferenceSuggestion([])
    }

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />


                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                      <span className="h4">Consulta de Referencia</span>
                    </div>
                  
                    <div className="col-12 pt-1 pb-3 ps-2 pe-2">
                    <div className="row ">
                      <div className="col-12 ">
                        <div className="w-100 d-flex justify-content-end">
                        
                          <Tooltip title="Filtrar" placement="top-start" arrow>
                            <button className="btn custom-btn-icons" 
                            type="button" data-bs-toggle="collapse" 
                            data-bs-target="#collapseExample" aria-expanded="false" 
                            aria-controls="collapseExample">
                              <i className="fas fa-filter"></i>
                            </button>
                          </Tooltip>
                        </div>
                        <div className="collapse show" id="collapseExample">
                          <div className="filter-continer">
                            <div className="container mt-3">
                              <form className="row">
                              <div className="col-12 mb-3">
                                <FormControl component="fieldset" className=" w-100 ">
                                  <FormLabel className="filterName" component="legend">
                                    Estado de facturas
                                  </FormLabel>
                                  {/* <RadioGroup className="ms-md-12 ps-md-12 w-100" aria-label="invoice" name="invoice" row value={selectedStatusValue} onChange={handleChangeStatus}>
                                    <FormControlLabel value="Facturas" control={<CustomRadio />} label="Facturas" />
                                    <FormControlLabel value="Anticipo" control={<CustomRadio />} label="Anticipos/Contado" />
                                  </RadioGroup> */}
                                </FormControl>
                              </div>
                              <div className="col-md-5 col-lg-4 mb-3">
                                                        <TextField
                                                            select
                                                            required
                                                            id="an8"
                                                            name="an8"
                                                            label={"Seleccione Filtro"}
                                                            variant="outlined"
                                                            size="small" 
                                                           
                                                            fullWidth
                                                            defaultValue={location.state?.customer ? location.state?.customer : ''}
                                                            {...register('filterSelector')}
                                                            error={!!errors.an8}
                                                            onChange={onCustomerChange}
                                                            >
                                                                <MenuItem value="">Seleccionar Filtro</MenuItem>
                                                            {filterState.map(({value, label}) => (
                                                                <MenuItem  key={value+label} value={value}>
                                                                    {label}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                        <Typography variant="inherit" color="error">
                                                            {errors?.an8?.message}
                                                        </Typography>
                                                    </div>

                                                    {
                                                      filterParams === "F" && (
                              <>

                                <div className="col-md-5 col-lg-4 mb-3">
                                        <MuiPickersUtilsProvider
                                          utils={DateFnsUtils}
                                          locale={esLocale}
                                        >
                                          <DatePicker
                                            disableToolbar
                                            autoOk
                                            fullWidth
                                            ampm={false}
                                            // minDate={new Date(Math.min(...yearsPayment.map(Number)), 0, 1)}
                                            // maxDate={new Date(Math.max(...yearsPayment.map(Number)), 11, 31)}
                                            disableFuture
                                            id="startDate"
                                            name="startDate"
                                            inputVariant="outlined"
                                            variant="inline"
                                            label={`${selectedStatusValue === "Facturas" ? "Fecha y Hora de Factura Inicio" : "Fecha y Hora de Anticipo Inicio"}`}
                                            size="small"
                                            format="dd/LLLL/yyyy"
                                            value={startDate}
                                            onChange={setStartDate}
                                            // disabled={yearsPayment.length === 0 || monthsPayment.length === 0}
                                            // shouldDisableDate={(date) => {
                                            //   const year = date.getFullYear();
                                            //   return !yearsPayment.includes(year);
                                            // }}
                                            // onBlur={sortDetailPayment}
                                            TextFieldProps={{
                                              error: false,
                                              helperText: ""
                                            }}
                                          />

                                        </MuiPickersUtilsProvider>
                                    </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                        <MuiPickersUtilsProvider
                                          utils={DateFnsUtils}
                                          locale={esLocale}
                                        >
                                            <DatePicker
                                            disableToolbar
                                            autoOk
                                            fullWidth
                                            ampm={false}
                                            // minDate={new Date(Math.min(...yearsPayment.map(Number)), 0, 1)}
                                              // maxDate={new Date(Math.max(...yearsPayment.map(Number)), 11, 31)}
                                            id="endDate"
                                            name="endtDate"
                                            inputVariant="outlined"
                                            variant="inline"
                                            label={`${selectedStatusValue === "Facturas" ? "Fecha y Hora de Factura Fin" : "Fecha y Hora de Anticipo Fin"}`}
                                            size="small"
                                            format="dd/LLLL/yyyy"
                                            value={endDate}
                                            onChange={setEndDate}
                                            // disabled={yearsPayment.length === 0 || monthsPayment.length === 0}
                                           
                                            // onBlur={sortDetailPayment}
                                            TextFieldProps={{
                                              error: false,
                                              helperText: ""
                                            }}
                                          />
                                        </MuiPickersUtilsProvider>
                                    </div>
                              </>
                                                      )
                                                    }
                                                    {
                                                      filterParams === "MyF" && (
                              <>

                                <div className="col-md-5 col-lg-4 mb-3">
                                        <MuiPickersUtilsProvider
                                          utils={DateFnsUtils}
                                          locale={esLocale}
                                        >
                                          <DatePicker
                                            disableToolbar
                                            autoOk
                                            fullWidth
                                            disableFuture
                                            ampm={false}
                                            // minDate={new Date(Math.min(...yearsPayment.map(Number)), 0, 1)}
                                            // maxDate={new Date(Math.max(...yearsPayment.map(Number)), 11, 31)}
                                            id="startDate"
                                            name="startDate"
                                            inputVariant="outlined"
                                            variant="inline"
                                            label={`${selectedStatusValue === "Facturas" ? "Fecha y Hora de Factura Inicio" : "Fecha y Hora de Anticipo Inicio"}`}
                                            size="small"
                                            format="dd/LLLL/yyyy"
                                            value={startDate}
                                            onChange={setStartDate}
                                            // disabled={yearsPayment.length === 0 || monthsPayment.length === 0}
                                            // shouldDisableDate={(date) => {
                                            //   const year = date.getFullYear();
                                            //   return !yearsPayment.includes(year);
                                            // }}
                                            // onBlur={sortDetailPayment}
                                            TextFieldProps={{
                                              error: false,
                                              helperText: ""
                                            }}
                                          />

                                        </MuiPickersUtilsProvider>
                                    </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                        <MuiPickersUtilsProvider
                                          utils={DateFnsUtils}
                                          locale={esLocale}
                                        >
                                            <DatePicker
                                            disableToolbar
                                            
                                            autoOk
                                            fullWidth
                                            ampm={false}
                                            // minDate={new Date(Math.min(...yearsPayment.map(Number)), 0, 1)}
                                              // maxDate={new Date(Math.max(...yearsPayment.map(Number)), 11, 31)}
                                            id="endDate"
                                            name="endtDate"
                                            inputVariant="outlined"
                                            variant="inline"
                                            label={`${selectedStatusValue === "Facturas" ? "Fecha y Hora de Factura Fin" : "Fecha y Hora de Anticipo Fin"}`}
                                            size="small"
                                            format="dd/LLLL/yyyy "
                                            value={endDate}
                                            onChange={setEndDate}
                                            // disabled={yearsPayment.length === 0 || monthsPayment.length === 0}
                                            
                                            // onBlur={sortDetailPayment}
                                            TextFieldProps={{
                                              error: false,
                                              helperText: ""
                                            }}
                                          />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="col-md-5 col-lg-4 mb-3"></div>
                                    <div className="col-md-5 col-lg-4 mb-3">
                                        <TextField
                                          
                                          id="startAmountFilter"
                                          name="startAmountFilter"
                                          label="Busqueda monto inicio*"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('amountFrom')}
                                          
                                          />
                                          {
                                            errors.amountFrom&& (
                                              <span className="text-danger">{errors.amountFrom.message}</span>
                                            )
                                          }
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                        <TextField
                                          
                                          id="endAmountFilter"
                                          name="endAmountFilter"
                                          label="Busqueda monto fin*"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('amountUpTo')}
                                          
                                          // disabled={getValues().an8 === "" || getValues().an8 === undefined}
                                          //onBlur={onSubmit}
                                          />
                                          {
                                            errors.amountUpTo&& (
                                              <span className="text-danger">{errors.amountUpTo.message}</span>
                                            )
                                          }
                                </div>
                              </>
                                                      )
                                                    }
                                                    {
                                                      filterParams === "M" && ( 
                              <>
                                <div className="col-md-5 col-lg-4 mb-3">
                                        <TextField
                                          
                                          id="startAmountFilter"
                                          name="startAmountFilter"
                                          label="Busqueda monto inicio*"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('amountFrom')}
                                          
                                          />
                                          {
                                            errors.amountFrom&& (
                                              <span className="text-danger">{errors.amountFrom.message}</span>
                                            )
                                          }
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                        <TextField
                                          
                                          id="endAmountFilter"
                                          name="endAmountFilter"
                                          label="Busqueda monto fin*"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('amountUpTo')}
                                          
                                          // disabled={getValues().an8 === "" || getValues().an8 === undefined}
                                          //onBlur={onSubmit}
                                          />
                                          {
                                            errors.amountUpTo&& (
                                              <span className="text-danger">{errors.amountUpTo.message}</span>
                                            )
                                          }
                                </div>
                              </>
                                                      )
                                                    }
                                                    {
                                                      filterParams === "RyF" && (
                              <>
                              <div className="col-md-5 col-lg-4 mb-3">
                                        <MuiPickersUtilsProvider
                                          utils={DateFnsUtils}
                                          locale={esLocale}
                                        >
                                          <DatePicker
                                            disableToolbar
                                            autoOk
                                            fullWidth
                                            disableFuture
                                            ampm={false}
                                            // minDate={new Date(Math.min(...yearsPayment.map(Number)), 0, 1)}
                                            // maxDate={new Date(Math.max(...yearsPayment.map(Number)), 11, 31)}
                                            id="startDate"
                                            name="startDate"
                                            inputVariant="outlined"
                                            variant="inline"
                                            label={`${selectedStatusValue === "Facturas" ? "Fecha y Hora de Factura Inicio" : "Fecha y Hora de Anticipo Inicio"}`}
                                            size="small"
                                            format="dd/LLLL/yyyy "
                                            value={startDate}
                                            onChange={setStartDate}
                                            // disabled={yearsPayment.length === 0 || monthsPayment.length === 0}
                                            // shouldDisableDate={(date) => {
                                            //   const year = date.getFullYear();
                                            //   return !yearsPayment.includes(year);
                                            // }}
                                            // onBlur={sortDetailPayment}
                                            TextFieldProps={{
                                              error: false,
                                              helperText: ""
                                            }}
                                          />

                                        </MuiPickersUtilsProvider>
                                    </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                        <MuiPickersUtilsProvider
                                          utils={DateFnsUtils}
                                          locale={esLocale}
                                        >
                                            <DatePicker
                                            disableToolbar
                                            
                                            autoOk
                                            fullWidth
                                            
                                            // minDate={new Date(Math.min(...yearsPayment.map(Number)), 0, 1)}
                                              // maxDate={new Date(Math.max(...yearsPayment.map(Number)), 11, 31)}
                                            id="endDate"
                                            name="endtDate"
                                            ampm={false}
                                            inputVariant="outlined"
                                            variant="inline"
                                            label={`${selectedStatusValue === "Facturas" ? "Fecha y Hora de Factura Fin" : "Fecha y Hora de Anticipo Fin"}`}
                                            size="small"
                                            format="dd/LLLL/yyyy "
                                            
                                            value={endDate}
                                            onChange={setEndDate}
                                            // disabled={yearsPayment.length === 0 || monthsPayment.length === 0}
                                            
                                            // onBlur={sortDetailPayment}
                                            TextFieldProps={{
                                              error: false,
                                              helperText: ""
                                            }}
                                          />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="col-md-5 col-lg-4 mb-3"></div>
                                    <div className="col-md-5 col-lg-4 mb-3" style={{position:"relative"}}>
                                <TextField
                                          
                                          id="refPam"
                                          name="refPam"
                                          label="Busqueda referencia*"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('refStatus')}
                                          
                                          // disabled={getValues().an8 === "" || getValues().an8 === undefined}
                                          //onBlur={onSubmit}
                                          
                                          />
                                           {suggestedReferences.length > 0 && referencePam.length>0 && (
                                              <ul style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                right: 0,
                                                backgroundColor: '#fff',
                                                listStyle: 'none',
                                                padding: 0,
                                                margin: 0,
                                                border: '1px solid #ccc',
                                                zIndex: 10
                                              }}>
                                                {suggestedReferences.map((item, idx) => (
                                                  <li
                                                    key={idx}
                                                    className='hoverList'
                                                    style={{ padding: '8px', cursor: 'pointer' }}
                                                    onMouseDown={()=>handleSetReferencePam(item)} // usar onMouseDown en lugar de onClick evita que se cierre antes del blur
                                                  >
                                                    {item.refpan}
                                                  </li>
                                                ))}
                                              </ul>
                                            )}
                                </div>
                                
                                
                              </>
                                                      )
                                                    }
                                                    { 
                                                      filterParams === "RyM" && (
                                                        <>
                                            <div className="col-md-5 col-lg-4 mb-3">
                                        <TextField
                                          
                                          id="startAmountFilter"
                                          name="startAmountFilter"
                                          label="Busqueda monto inicio*"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('amountFrom')}
                                          
                                          />
                                          {
                                            errors.amountFrom&& (
                                              <span className="text-danger">{errors.amountFrom.message}</span>
                                            )
                                          }
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                        <TextField
                                          
                                          id="endAmountFilter"
                                          name="endAmountFilter"
                                          label="Busqueda monto fin*"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('amountUpTo')}
                                          
                                          // disabled={getValues().an8 === "" || getValues().an8 === undefined}
                                          //onBlur={onSubmit}
                                          />
                                          {
                                            errors.amountUpTo&& (
                                              <span className="text-danger">{errors.amountUpTo.message}</span>
                                            )
                                          }
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3"></div>
                              <div className="col-md-5 col-lg-4 mb-3" style={{position:"relative"}}>
                                <TextField
                                          
                                          id="refPam"
                                          name="refPam"
                                          label="Busqueda referencia*"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('refStatus')}
                                          
                                          // disabled={getValues().an8 === "" || getValues().an8 === undefined}
                                          //onBlur={onSubmit}
                                         
                                          />
                                           {suggestedReferences.length > 0 && referencePam.length>0 && (
                                              <ul style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                right: 0,
                                                backgroundColor: '#fff',
                                                listStyle: 'none',
                                                padding: 0,
                                                margin: 0,
                                                border: '1px solid #ccc',
                                                zIndex: 10
                                              }}>
                                                {suggestedReferences.map((item, idx) => (
                                                  <li
                                                    key={idx}
                                                    className='hoverList'
                                                    style={{ padding: '8px', cursor: 'pointer' }}
                                                    onMouseDown={()=>handleSetReferencePam(item)} // usar onMouseDown en lugar de onClick evita que se cierre antes del blur
                                                  >
                                                    {item.refpan}
                                                  </li>
                                                ))}
                                              </ul>
                                            )}
                                </div>
                                
                                                        </>
                                                      )
                                                    }
                                                          
                                <div className="col-12 w-100 d-flex justify-content-end">
                                  <Tooltip title="Buscar" placement="top-start" arrow>
                                    <div>
                                      <button 
                                      className="ms-2 mb-3 btn custom-btn"
                                      disabled={isLoadingData || isLoadingFilters}
                                      onClick={handleSubmit(onSubmit)}
                                      type='submit'
                                      aria-label="submit filter"
                                      >
                                        <i className="fas fa-search"></i>
                                      </button>
                                    </div>
                                  </Tooltip>
                                </div>
                            </form>
                            </div>
                          
                          </div>
                        </div>
                            
                            
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                        <div className='table-wrap'>
                          <table
                            className=""
                            {...getTableProps()}
                          >
                            <thead>
                              {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()} className="border-content " key={`${headerGroup?.id}-header-group`}>
                                  {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps()}
                                    className="border-element header-element header-text pt-3 pb-3" key={`${column?.id}-column-group`}>
                                      {column.render("Header")}
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              {rows.map((row) => {
                                prepareRow(row);
                                return (
                                  <React.Fragment key={row.getRowProps().key}>
                                    <tr className="element-row border-content">
                                      {row.cells.map((cell) => {
                                        return (
                                          <td className="border-element content-text padding-row"
                                           
                                          {...cell.getCellProps()} key={`${cell?.row?.id}-td-element-${cell?.column?.value}-${cell?.column?.Header}`}>
                                                      {console.log(cell.row.original.totalAmount,"cellvalue")}
                                            {
                                              cell.column.id === 'an8' ?
                                                getValues().an8 : 
                                                (cell.column.Header === 'Monto'?
                                                  `$ ${parseFloat(cell.value).toLocaleString(currencySelected,{
                                                    minimumFractionDigits: 2
                                                })}` : cell.render("Cell"))
                                              }
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                            <DataStatus isErrorResponse={isErrorResponse} isLoadingData={isLoadingData} data={detailPayment} errorResponse={errorResponse} messageError="Los filtros seleccionados no devilvieron coincidencias." isSubmitingData={false} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
            <Footer/>
        </>
    )
}
const ModalDetailPayment = ({row, dataPayment,  updateReferenceTable}) => {

  return (
          <Modal>
            <Modal.Open opens={`reference-detail-${row.index}`}>
                <button style={{display:"none"}}  id={`reference-detail-${row.index}`} className='btn'><i className="fas fa-eye link-secondary"></i></button>
            </Modal.Open>
            <Modal.Window name={`reference-detail-${row.index}`}>
              <ReferenceModal dataPayment={dataPayment} updateReferenceTable={updateReferenceTable}  />
            </Modal.Window>
          </Modal>
    )
  }
  // Agregar PropTypes para validar las props
ModalDetailPayment.propTypes = {
  row: PropTypes.any,
  dataPayment: PropTypes.object.isRequired, // `dataPayment` debe ser un objeto
  updateReferenceTable: PropTypes.func, // `updateReferenceTable` es una función opcional
};
